import { IApplicationState } from '../../types/redux';

export function getIsSelfEmployed(state: IApplicationState) {
  return state.newbuilding.newbuildingBroker?.isNeedSelfEmployedConfirmation || false;
}
